import api from 'utils/apiClient';

export const loadGiftsCategories = (params) => {
  return api.get('/gift_categories', {
    params,
  })
}

export const createGiftsCategory = (data) => {
  return api.post('/gift_categories', data)
}

export const editGiftsCategory = ({id, ...data}) => {
  return api.patch(`/gift_categories/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
  })
}

export const deleteGiftsCategory = (id) => {
  return api.delete(`/gift_categories/${id}`)
}

export const loadGifts = ({archived, ...params}) => {
  return api.get(`${archived ? '/gifts/archived' : '/gifts'}`, {
    params
  })
}

export const createGift = (data) => {
  return api.post('/gifts', data)
}

export const editGift = ({id, ...data}) => {
  return api.patch(`/gifts/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
  })
}